const isChartUrl = (chartIdOrUrl: string): boolean =>
  /^https?:\/\/[\w.]+amplitude\.com\/.*\/chart\/[\w-]+/.test(chartIdOrUrl?.toString() || '')

export default isChartUrl
